import { Grid, SvgIcon } from '@material-ui/core';
import React from 'react';
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';
import { useTranslation } from 'react-i18next';
import BaseButton from '../../common/components/base-button';
import { ReactComponent as GoBackIcon } from '../media/go-back-icon.svg';
import { transactionSearchModalStyles } from '../transaction-based-return-styles';

export interface IFindTransactionButtonProps {
  onSearch: () => Promise<void>;
  onCancel: () => void;
  onBack: () => void;
}

const SearchByParameterScreenActionButtons: React.FC<IFindTransactionButtonProps> = (
  props: IFindTransactionButtonProps,
): JSX.Element => {
  const classes = transactionSearchModalStyles();
  const { t } = useTranslation();

  return (
    <Grid item className={classes.searchButtonStyle}>
      <BaseButton
        buttonType='white'
        className={classes.actionButtons}
        onClick={props.onBack}
        startIcon={
          <SvgIcon>
            <GoBackIcon />
          </SvgIcon>
        }
        data-testid={'transaction-search-screen-previous-button'}
      >
        {t('Back')}
      </BaseButton>
      <BaseButton
        buttonType='white'
        className={classes.actionButtons}
        onClick={props.onCancel}
        data-testid={'transaction-search-screen-cancel-button'}
      >
        {t('Cancel')}
      </BaseButton>
      <BaseButton
        buttonType='primary'
        className={classes.actionButtons}
        onClick={props.onSearch}
        data-testid={'transaction-search-screen-submit-button'}
      >
        {t('Search')}
      </BaseButton>
    </Grid>
  );
};

export default SearchByParameterScreenActionButtons;
